var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0498 13.7502V9.5835",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0837 11.6665H7.91699",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3337 9.1665V14.1665C18.3337 17.4998 17.5003 18.3332 14.167 18.3332H5.83366C2.50033 18.3332 1.66699 17.4998 1.66699 14.1665V5.83317C1.66699 2.49984 2.50033 1.6665 5.83366 1.6665H7.08366C8.33366 1.6665 8.60866 2.03317 9.08366 2.6665L10.3337 4.33317C10.6503 4.74984 10.8337 4.99984 11.667 4.99984H14.167C17.5003 4.99984 18.3337 5.83317 18.3337 9.1665Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperFolderIcon);
export default __webpack_public_path__ + "static/media/stepper-folder-icon.73c05db19e1ebb50ba1c64addaefcd25.svg";
export { ForwardRef as ReactComponent };